/**
 * Export all app data to JSON file
 */
export const exportData = (startDate, partnerNames, anniversaries) => {
  const data = { startDate, partnerNames, anniversaries };
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'love-counter-data.json';
  a.click();
  URL.revokeObjectURL(url);
};

/**
 * Import data from JSON file
 */
export const importData = (file, callback) => {
  if (!file) return;
  
  const reader = new FileReader();
  reader.onload = (event) => {
    try {
      const data = JSON.parse(event.target.result);
      callback(data, null);
    } catch (error) {
      callback(null, 'Invalid JSON file');
    }
  };
  reader.readAsText(file);
};